import React, { useEffect, useRef, useState } from "react";
import {
  getFname,
  getDname,
  getUserEmail,
  getroleName,
  getUserId,
  passwordChange,
  HEADERS,
} from "../../pages/api.js";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import BusinessIcon from "@mui/icons-material/Business";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import Swal from "sweetalert2";
const Header = () => {
  const dropdownRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [currentTime, setCurrentTime] = useState(new Date());

  const toggleDropdown = () => setIsOpen((prev) => !prev);
  const firstName = getFname();
  const name = `${firstName} `;
  const Dname = getDname();
  const role = getroleName();
  const email = getUserEmail();
  const userId = getUserId();

  const getGreeting = () => {
    const hour = currentTime.getHours();
    if (hour < 12) return "Good Morning";
    else if (hour < 17) return "Good Afternoon";
    else return "Good Evening";
  };

  const handleLogout = () => {
    sessionStorage.clear();
    window.location.href = "/login";
  };

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  const handleChangePassword = async () => {
    const { value: formValues } = await Swal.fire({
      html: `
    <form autocomplete="off" onsubmit="return false;">
      <h5 class="mt-2"><strong>Change Password</strong></h5>
      <div class="p-1 d-flex flex-column gap-2">
        <div class="d-flex flex-column">
          <small class="text-start">Old Password</small>
          <input id="swal-old-password" type='password' class="form-control mt-1" placeholder="Enter old password" autocomplete="new-password">
        </div>
        <div class="d-flex flex-column">
          <small class="text-start">New Password</small>
          <input id="swal-new-password" type='password' class="form-control mt-1" placeholder="Enter new password" autocomplete="new-password">
        </div>
        <div class="d-flex flex-column">
          <small class="text-start">Confirm Password</small>
          <input id="swal-confirm-password" type='password' class="form-control mt-1" placeholder="Confirm new password" autocomplete="new-password">
        </div>
      </div>
    </form>
    `,
      focusConfirm: false,
      showCancelButton: true,
      confirmButtonText: "Submit",
      confirmButtonColor: "#2d7d9f",
      reverseButtons: true,
      preConfirm: () => {
        const oldPassword = document.getElementById("swal-old-password").value;
        const newPassword = document.getElementById("swal-new-password").value;
        const confirmPassword = document.getElementById(
          "swal-confirm-password"
        ).value;

        if (!oldPassword || !newPassword || !confirmPassword) {
          Swal.showValidationMessage("Please fill in all fields");
          return false;
        }

        if (
          oldPassword.length < 4 ||
          newPassword.length < 4 ||
          confirmPassword.length < 4
        ) {
          Swal.showValidationMessage("Password must be at least 4 characters");
          return false;
        }

        if (newPassword !== confirmPassword) {
          Swal.showValidationMessage("New and confirm passwords do not match");
          return false;
        }

        return { oldPassword, newPassword, confirmPassword };
      },
    });

    if (formValues) {
      const userId = getUserId();
      const payload = {
        user_id: userId,
        old_pass: formValues.oldPassword,
        new_pass: formValues.newPassword,
        confirm_pass: formValues.confirmPassword,
      };

      try {
        const response = await fetch(passwordChange, {
          method: "POST",
          headers: HEADERS,
          body: JSON.stringify(payload),
        });

        const responseData = await response.json();
        console.log(response);
        if (response.ok && responseData.response_code === "0000") {
          await Swal.fire({
            icon: "success",
            title: "Success",
            text: responseData.response_description,
            confirmButtonColor: "#2d7d9f",
          });
        } else {
          await Swal.fire({
            icon: "error",
            title: "Failed",
            text: responseData.response_description || "Something went wrong.",
            confirmButtonColor: "#2d7d9f",
          });
        }
      } catch (error) {
        console.error("Change password error:", error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "An error occurred while changing the password.",
          confirmButtonColor: "#2d7d9f",
        });
      }
    }
  };

  return (
    <div className="d-flex justify-content-end p-2">
      <div className="user-icon-dropdown" ref={dropdownRef}>
        <div className="user-detailss">
          <button
            className="d-flex gap-3 align-items-center user-icon"
            onClick={toggleDropdown}
          >
            <span>
              <strong style={{ color: "#505050" }}>{name}</strong>
            </span>
            <PersonOutlineIcon style={{ color: "#505050" }} />
          </button>
          <div className={`dropdown-menu p-4 ${isOpen ? "show" : ""}`}>
            <div className="greeting">
              <strong>
                {getGreeting()}, {name} !
              </strong>
            </div>
            <hr className="line-hori" />
            <div className="d-flex flex-row gap-3 align-items-center departments mt-2">
              <WorkOutlineIcon style={{ fontSize: "20px", color: "#2d7d9f" }} />
              <span className="text-uppercase">{role}</span>
            </div>
            <div className="d-flex flex-row gap-3 align-items-center departments mt-2">
              <BusinessIcon style={{ fontSize: "20px", color: "#2d7d9f" }} />
              <span>{Dname}</span>
            </div>
            <div className="d-flex flex-row gap-3 align-items-center departments mt-2">
              <EmailOutlinedIcon
                style={{ fontSize: "20px", color: "#2d7d9f" }}
              />
              <span>{email}</span>
            </div>
            <hr className="line-hori" />
            <div
              className="d-flex flex-row gap-3 align-items-center departments mt-2"
              style={{ cursor: "pointer" }}
              onClick={handleChangePassword}
            >
              <LockOpenIcon style={{ fontSize: "20px", color: "#2d7d9f" }} />
              <span>Change Password</span>
            </div>
            <div
              style={{ cursor: "pointer" }}
              className="mt-4 add-button d-flex flex-row justify-content-between align-items-center rounded"
              onClick={handleLogout}
            >
              <span className="">Logout</span>
              <ExitToAppIcon style={{ fontSize: "20px", color: "#fff" }} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
